<template>
    <div class="leaves">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Leaves Approvals</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Leaves Approvals</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="leaves"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    {{
                      item.approvedDate
                        ? new Date(item.approvedDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.request`]="{ item }">
                    {{
                      item.employeeLeave.employee.firstName + ' ' + item.employeeLeave.employee.lastName
                    }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.employeeLeave.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Pending
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.employeeLeave.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.employeeLeave.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <!-- /Page Content -->
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data () {
    return {
      leaves: [],
      headers: [
        { text: 'Requester', value: 'request' },
        { text: 'Approved Date', value: 'date' },
        { text: 'Approval', value: 'status' }
      ],
      currentUser: authenticationService.currentUserValue
    }
  },
  methods: {
    getApprovals () {
        var userId = this.currentUser.employee.id
        employeeService.getLeavesApprovals(userId).then(
          model => {
            console.log(model)
            this.leaves = model;
          },
          error => {
            console.log(error)
          }
        )
    }
  },
  mounted() {
    this.getApprovals()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/leaves/leavesApprovals.vue